export default __webpack_public_path__ + "static/media/create-account.ea5702aa.svg";